import { useState } from 'react'

import { Slider } from '@/components/ui/slider'
import { Demo, DsSection } from '../primitives'

export function SliderSection() {
  const [share, setShare] = useState([35])
  const [stepped, setStepped] = useState([50])

  return (
    <DsSection
      id="slider"
      title="Slider"
      intro="Radix slider on a 0–100 track. Always pass aria-label and, when the number needs words, aria-valuetext; both go on the thumb."
    >
      <Demo label="Default" className="flex max-w-sm flex-col gap-2">
        <Slider value={share} onValueChange={setShare} aria-label="Share" aria-valuetext={`${share[0]}%`} />
        <span className="text-ink-500 text-sm">{share[0]}%</span>
      </Demo>
      <Demo label="step={5}" className="flex max-w-sm flex-col gap-2">
        <Slider
          value={stepped}
          onValueChange={setStepped}
          step={5}
          aria-label="Stepped share"
          aria-valuetext={`${stepped[0]}%`}
        />
        <span className="text-ink-500 text-sm">{stepped[0]}%</span>
      </Demo>
      <Demo label="disabled" className="max-w-sm">
        <Slider value={[100]} disabled aria-label="Disabled share" />
      </Demo>
    </DsSection>
  )
}
